import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App)

import router from './router'
import BootstrapVue3 from 'bootstrap-vue-3'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { createI18n } from "vue-i18n";
library.add(far, fas, fab)

// import { i18n } from './i18n'
const i18n = createI18n({
    locale: process.env.VUE_DEFAULT_LOCALE,
    messages: loadLocaleMessages(),
});

import { createPinia } from 'pinia'
import { store } from './store';
const pinia = createPinia()

app.use(store)
app.use(router)
app.use(pinia)
app.use(BootstrapVue3)
app.use(i18n)
app.component('font-awesome-icon', FontAwesomeIcon)
app.mount('#app')

function loadLocaleMessages() {
    const locales = require.context(
        "./locales",
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i
    );
    const messages: any = {};
    locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}